<template>
  <span class="icon" >
    <img :src="src" />
  </span>
</template>

<script>
export default {
  props: {
    name: String
  },
  computed: {
    src() {
      return require(`../../assets/icons/${this.name}.svg`);
    }
  }
};
</script>


<style scoped>
  .icon {
    color: inherit;
    display: inline-block;
    vertical-align: middle;
    fill: currentColor;
  }
</style>